import './styles.scss';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import { Button } from '@edx/paragon';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { injectIntl } from 'gatsby-plugin-react-intl';

import { intlShape } from '@prospectus/common/types/intlShape';
import { submitEvent } from '@utils/analytics';
import useSearchParams from '@prospectus/common/hooks/useSearchParams';
import { WebviewContext, SearchPageContext } from '@utils/context';
import { clearAllFilters } from '@data/actions/filters';
import messages from '../../messages';

function ClearRefinements(props) {
  const {
    className, intl,
  } = props;
  const { clearRefinements } = useSearchParams();
  const webview = useContext(WebviewContext);
  const { pageType } = useContext(SearchPageContext);
  const dispatch = useDispatch();

  const sendAnalyticsEvent = () => {
    const componentProps = {
      category: 'search',
    };

    submitEvent(props.tracking, componentProps, 'edx.bi.user.facets.cleared');
  };
  //
  const clearAllRefinements = () => {
    sendAnalyticsEvent();
    // Maintain the tab param in webview.
    if (pageType !== 'shop-page') {
      clearRefinements(webview ? ['tab'] : []);
    }
    dispatch(clearAllFilters());
  };

  return (
    <Button
      variant="link"
      className={classNames(className, 'text-gray-700 text-decoration-underline')}
      onClick={clearAllRefinements}
    >{intl.formatMessage(messages['prospectus.search.new.selected_facets.clear'])}
    </Button>
  );
}

ClearRefinements.propTypes = {
  tracking: PropTypes.shape().isRequired,
  className: PropTypes.string,
  intl: intlShape.isRequired,
};

ClearRefinements.defaultProps = {
  className: 'btn btn-clear-refinements',
};

export default track({
  component: 'clear-refinements',
})(injectIntl(ClearRefinements));
